import React, { Component } from 'react';
import { CustomCard } from "../../../../components/Card/CustomCard";
import { Timeline, Event } from "react-timeline-scribble";

class Filosofia extends Component {

    contenido = () => (
        <div id="filosofia">
            <Timeline>
                <Event interval="Filosofía Institucional">
                    <p className="fuente-monserrat" align="justify">
                        El Instituto Universitario de Diseño Las Mercedes fue creado el 3 de junio de 1999, según Gaceta Oficial N° 309.574, de fecha 9 de junio de 1999 y el 15 de septiembre de ese mismo año inicia sus actividades ofreciendo estudios a nivel de Técnico Superior Universitario, en las especialidades de: Diseño Gráfico, Diseño Interior, Diseño de Moda, Diseño Textil y Publicidad y Mercadeo.
                    </p>
                </Event>
            </Timeline>
        </div>
    )

    render() { 
        return (
            <CustomCard
                content={this.contenido()}
            /> 
        );
    }
}
 
export default Filosofia;


// WEBPACK FOOTER //
// ./src/site/Componentes/Institucion/Contenido/Filosofia.jsx